<script>
// import RexTabView from '@/rex-components/RexTabView.vue';
import RexTabsV3 from '@/rex-components/RexTabsV3.vue';
import LogNavSearch from '@/components/Log/LogNavSearch.vue';
import LogNavListOptions from '@/components/Log/LogNavListOptions.vue';
import { LOGService } from '@/services/api/log.service';
import { mapGetters, mapMutations, mapState } from 'vuex';
import {
  lmNavbarTabs,
  anlyNavbarTabs,
  getRouteName,
} from '@/components/Log/log.types';
import {
  timeStamp,
  RAW,
  LOG_PAGE_SIZE,
  DESC,
  DEBOUNCE_INPUT_TIME,
  THROTTLE_INPUT_TIME,
} from '@/components/Log/log.constants';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import RexSpinV3 from '@/rex-components/RexSpinV3.vue';

export default {
  components: {
    RexTabsV3,
    LogNavSearch,
    LogNavListOptions,
    RexSpinV3,
  },
  computed: {
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('logState/logCommonState', [
      'sourceList',
      'isADType',
      'anlyInfoFieldsList',
      'logInfoFieldsList',
      'tagLoading',
      'sourceCurrentPage',
    ]),
    ...mapGetters('logState/logCommonState', ['getCapabilityType']),
    ...mapState('globalState/user', ['teamID']),
    getSourceList() {
      return this.sourceList;
    },
    getTagsList() {
      return this.tagsList;
    },
    getFieldsList() {
      return this.filterList(this.fieldsList);
    },
    searchPlaceholder() {
      switch (this.currTab) {
        case '1':
          return this.$t('log.searchServices');
        case '2':
          return this.isADType
            ? this.$t('analytics.searchScriptNames')
            : this.$t('log.searchLogName');
        default:
          return this.$t('log.searchFields');
      }
    },
    getSourceId() {
      return this.$route.query.source
        ? this.$route.query.source?.split(',')[0]
        : '';
    },
    getSearchValue() {
      return this.$route?.query?.search ?? '';
    },
    showLoader() {
      return (
        (this.currTab === '2' &&
          this.tagCurrentPage === 1 &&
          this.tagLoading) ||
        (this.currTab === '1' &&
          this.sourceCurrentPage === 1 &&
          this.isSourceLoading)
      );
    },
    getTabs() {
      return this.isADType ? anlyNavbarTabs() : lmNavbarTabs();
    },
  },
  data() {
    return {
      currTab: '1',
      checkedSource: '',
      fieldsList: [],
      checkedFields: [],
      tagsList: [],
      checkedTag: '',
      pageSize: LOG_PAGE_SIZE,
      isSourceLoading: false,
      tagCurrentPage: 1,
      stopInfiniteScrollSources: false,
      stopInfiniteScrollTag: false,
      tagSearch: '',
      serviceSearch: '',
    };
  },
  methods: {
    ...mapMutations('logState/logCommonState', [
      'setTagLoading',
      'setAnlyInfoFieldsList',
      'setLogInfoFieldsList',
      'setSourceList',
      'setIsSearchListEmpty',
      'setSourceCurrentPage',
    ]),
    async fetchTags() {
      try {
        if (this.tagLoading) return;
        this.setTagLoading(true);
        const { data } = await LOGService.getTagsList({
          service_id: this.checkedSource,
          duration: this.getDurationTime,
          capability: this.getCapabilityType,
          limit: LOG_PAGE_SIZE,
          offset: this.tagCurrentPage,
          searchKeyword: this.tagSearch,
        });
        let formatedTagList =
          data?.data?.tags.map((tag) => ({ name: tag, value: tag })) ?? [];
        this.stopInfiniteScrollTag = formatedTagList.length < this.pageSize;
        this.tagCurrentPage === 1
          ? (this.tagsList = formatedTagList)
          : this.tagsList.push(...formatedTagList);
        if (this.tagsList.length === 0) {
          this.$router.push({
            name: getRouteName(this.isADType),
            query: { ...this.$route.query, tag: '' },
          });
          this.fieldsList = [];
        } else if (!this.$route.query.tag) {
          this.$router.push({
            name: getRouteName(this.isADType),
            query: { ...this.$route.query, tag: this.tagsList[0].value },
          });
        }
      } catch (error) {
        console.log('error', error);
        this.tagCurrentPage = 1;
        this.tagsList = [];
        this.stopInfiniteScrollTag = true;
      } finally {
        this.setTagLoading(false);
      }
    },
    tabChange(e) {
      this.currTab = e;
      if (this.$route.query.search?.trim()) {
        this.$router.push({
          name: getRouteName(this.isADType),
          query: { ...this.$route.query, search: '' },
        });
      }
      const reload =
        this.currTab === '1'
          ? this.serviceSearch.length > 0
          : this.tagSearch.length > 0;
      this.handleSearch('', reload);
    },
    onSourceChange(event, labelName, isGroup) {
      this.checkedSource = event.target.value;
      this.$router.push({
        name: getRouteName(this.isADType),
        query: {
          ...this.$route.query,
          source: `${event.target.value},${labelName}`,
          tag: '',
          fields: '',
          isGroup: isGroup,
        },
      });
    },
    onTagChange(event) {
      this.$router.push({
        name: getRouteName(this.isADType),
        query: { ...this.$route.query, tag: event.target.value, fields: '' },
      });
    },
    onFieldChange(event) {
      let currFields = this.$route.query.fields
        ? this.$route.query.fields.split(',')
        : [];

      if (currFields.length > 4 && event.target.checked) {
        event.target.checked = false;
        return;
      }

      if (event.target.checked) {
        currFields.push(`${event.target.value}`);
      } else {
        currFields = currFields.filter((field) => field !== event.target.value);
      }

      this.$router.push({
        name: getRouteName(this.isADType),
        query: { ...this.$route.query, fields: currFields.join(',') },
      });
    },
    filterList(list) {
      const search =
        this.$route.query && this.$route.query.search
          ? this.$route.query.search.toLowerCase()
          : '';
      return list.filter(
        (obj) => obj.name && obj.name.toLowerCase().includes(search),
      );
    },
    preSelctLogFields() {
      let preSelectedLogFields = [];
      this.fieldsList.some((item) => item.value === RAW) &&
        preSelectedLogFields.push(RAW);
      this.fieldsList.some((item) => item.value === timeStamp) &&
        preSelectedLogFields.push(timeStamp);
      return preSelectedLogFields;
    },
    async getSourcesOnScroll() {
      if (this.isSourceLoading) return;
      try {
        this.isSourceLoading = true;
        const { data } = await LOGService.getSourcesList({
          team_id: this.teamID,
          capability: this.getCapabilityType,
          duration: this.getDurationTime,
          limit: LOG_PAGE_SIZE,
          offset: this.sourceCurrentPage,
          order: DESC,
          searchKeyword: this.serviceSearch,
        });
        const sources = data
          ? data.map((obj) => ({
              name: obj?.service_name,
              value: obj?.service_id,
              isGroup: obj?.is_group,
              color: obj?.is_group ? 'rgb(59, 191, 85)' : 'rgb(245, 150, 0)',
            }))
          : [];
        this.setIsSearchListEmpty(
          sources.length === 0 && this.serviceSearch !== '',
        );
        this.stopInfiniteScrollSources = sources.length < this.pageSize;
        this.sourceCurrentPage === 1
          ? this.setSourceList([...sources])
          : this.setSourceList([...this.sourceList, ...sources]);
        this.isSourceLoading = false;
      } catch (error) {
        this.setSourceList([]);
        this.stopInfiniteScrollSources = true;
        this.isSourceLoading = false;
        if (error?.message?.toLowerCase()?.includes('timeout')) {
          notificationError(this.$t('log.timeoutErrMsg'));
        }
      }
    },
    handleSearch(val, reload = true) {
      this.$router.push({
        name: getRouteName(this.isADType),
        query: { ...this.$route.query, search: val },
      });
      switch (this.currTab) {
        case '1':
          this.serviceSearch = val;
          if (reload) {
            this.setSourceCurrentPage(1);
            this.getSourcesOnScroll();
          }
          break;
        case '2':
          this.tagSearch = val;
          if (reload) {
            this.tagCurrentPage = 1;
            this.fetchTags();
          }

          break;
      }
    },
    debouncedHandleSearch: debounce(function (val) {
      this.handleSearch(val);
    }, DEBOUNCE_INPUT_TIME),
    handleScroll: throttle(function () {
      if (!this.tagLoading && !this.isSourceLoading) {
        switch (this.currTab) {
          case '1':
            if (!this.stopInfiniteScrollSources) {
              this.setSourceCurrentPage(this.sourceCurrentPage + 1);
              this.getSourcesOnScroll();
            }
            break;
          case '2':
            if (!this.stopInfiniteScrollTag) {
              this.tagCurrentPage++;
              this.fetchTags();
            }
            break;
          default:
            break;
        }
      }
    }, THROTTLE_INPUT_TIME),
  },
  watch: {
    '$route.query.source': {
      immediate: true,
      handler() {
        const source = this.getSourceId;
        if (source && source.length > 0) {
          this.checkedSource = this.sourceList.find(
            (obj) => obj.value === source,
          )
            ? source
            : this.sourceList[0]?.value;
          this.tagsList = [];
          this.fetchTags();
        }
      },
    },
    '$route.query.tag': {
      immediate: true,
      handler() {
        this.isADType
          ? this.setAnlyInfoFieldsList([])
          : this.setLogInfoFieldsList([]);
        this.checkedTag = this.$route.query.tag;
      },
    },
    tagsList() {
      if (!this.tagLoading) {
        const checkedTagVal = this.checkedTag;
        this.checkedTag = this.tagsList?.find(
          (obj) => obj.value === checkedTagVal,
        )
          ? checkedTagVal
          : this.tagsList[0]?.value;
      }
    },
    '$route.query.fields': {
      immediate: true,
      handler() {
        this.checkedFields = this.$route.query?.fields?.split(',') || [];
      },
    },
    fieldsList() {
      const checkedFieldsList = this.checkedFields;
      const validFields = this.fieldsList
        ?.filter((obj) => checkedFieldsList.includes(obj.value))
        ?.map((obj) => obj.value);

      const preSelectedLogFields = !this.isADType
        ? this.preSelctLogFields()
        : [];

      if (validFields?.length != this.checkedFields?.length) {
        this.checkedFields =
          validFields?.length > 0
            ? validFields
            : !this.isADType && preSelectedLogFields.length > 0
              ? preSelectedLogFields
              : this.fieldsList?.slice(0, 5)?.map((obj) => obj.value);
        this.$router.push({
          name: getRouteName(this.isADType),
          query: {
            ...this.$route.query,
            fields: this.checkedFields?.join(','),
          },
        });
      }
    },
    anlyInfoFieldsList() {
      this.fieldsList = this.anlyInfoFieldsList.map((val, i) => ({
        name: val,
        value: val,
        checked: this.checkedFields?.length == 0 && i < 5,
      }));

      if (this.checkedFields?.length == 0)
        this.checkedFields = this.fieldsList
          .slice(0, 5)
          .map((item) => item.value);

      this.$router.push({
        name: getRouteName(this.isADType),
        query: {
          ...this.$route.query,
          fields: this.checkedFields?.join(','),
        },
      });
    },
    logInfoFieldsList() {
      if (!this.isADType) {
        this.fieldsList = this.logInfoFieldsList.map((val) => ({
          name: val,
          value: val,
        }));
        if (this.fieldsList.length > 0 && !this.$route.query.fields) {
          const preSelectedLogFields = this.preSelctLogFields();
          this.$router.push({
            name: 'log',
            query: {
              ...this.$route.query,
              fields:
                preSelectedLogFields.length > 0
                  ? preSelectedLogFields.join(',')
                  : this.fieldsList
                      .slice(0, 5)
                      .map((item) => item.value)
                      .join(','),
            },
          });
        }
      }
    },
    getDurationTime(newVal, oldVal) {
      if (newVal.start != oldVal.start || newVal.end != oldVal.end) {
        this.fetchTags();
      }
    },
  },
  unmounted() {
    this.setSourceCurrentPage(1);
  },
};
</script>

<template>
  <div class="tab-container">
    <RexTabsV3
      :tabs="getTabs"
      @onTabChange="tabChange"
      :activeKey="currTab"
      :destroyInactiveTabPane="true"
    >
      <template #tab-header>
        <LogNavSearch
          :placeholder="searchPlaceholder"
          :searchValue="getSearchValue"
          @onSearch="debouncedHandleSearch"
        />
        <RexSpinV3 v-if="showLoader" size="small" class="log-nav-loader" />
      </template>

      <template #tab-1>
        <LogNavListOptions
          v-if="!showLoader"
          :options="getSourceList"
          @onChange="onSourceChange"
          type="radio"
          :checkedItems="[checkedSource]"
          @loadMoreData="handleScroll"
          :isLoading="isSourceLoading"
        />
      </template>

      <template #tab-2>
        <LogNavListOptions
          v-if="!showLoader"
          :options="getTagsList"
          @onChange="onTagChange"
          type="radio"
          :checkedItems="[checkedTag]"
          @loadMoreData="handleScroll"
          :isLoading="tagLoading"
        />
      </template>

      <template #tab-3>
        <LogNavListOptions
          v-if="!showLoader"
          :options="getFieldsList"
          @onChange="onFieldChange"
          :checkedItems="checkedFields"
        />
      </template>
    </RexTabsV3>
  </div>
</template>

<style lang="scss" scoped>
.tab-container {
  height: 59.225rem;
  padding: 0.5rem 1.125rem 0.844rem;
  background-color: $bg-secondary;
  border-radius: 0.25rem;
}
:deep(.nav-tabs) {
  margin-right: 0.75rem;
}
:deep(.nav-link) {
  font-size: 1rem;
}
.log-nav-loader {
  margin-top: 1rem;
}
</style>
